import axios from "axios";

const axiosParams = {
    baseURL :"https://ppp-test.nuvei.com/ppp/api/v1/getSessionToken.do",
}

const axiosInstance = axios.create(axiosParams);

const api = () => {
    return {
        get:(url, config = {})=> axiosInstance.get(url, config),
        post:(url,body, config = {})=> axiosInstance.post(url, body, config)
    }
}

export default api(axiosInstance)